import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {NspUpgradeComponent} from '../publisher-ui/upgrade/nsp-upgrade.component';
import {PublisherApp} from '../publisher-ui/publisher.component';

const routes: Routes = [
    { path: 'upgradeapp', component: PublisherApp}
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);


// WEBPACK FOOTER //
// ./src/publisher/src/publisher-ui/publisher.routes.ts